import { Button } from 'components/UI/Button/Button';
import React from 'react';
import { useSelector } from 'react-redux';
import { getPurchaseCartTotalAmount } from 'reducers/purchases/PurchasesSelectors';
import { formatPurchaseAmount } from 'types/Purchase';
import classes from './PurchaseFooter.module.scss';

interface PurchaseFooterProps {
    label?: string;
    loading?: boolean;
    disabled?: boolean;
    // Without a submit handler the footer only shows the total, like the payment step before a card
    onSubmit?: () => void;
}

export const PurchaseFooter: React.FC<PurchaseFooterProps> = ({
    label,
    loading,
    disabled,
    onSubmit
}) => {
    const total = useSelector(getPurchaseCartTotalAmount);

    return (
        <div className={classes.root}>
            <p className={classes.total}>
                <span>Total</span>
                <span>{formatPurchaseAmount(total)}</span>
            </p>

            {onSubmit && (
                <Button fullWidth disabled={disabled} loading={loading} onClick={onSubmit}>
                    {label ?? 'Continue'}
                </Button>
            )}
        </div>
    );
};
